import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function MyAccount() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const loggedIn = sessionStorage.getItem("isLoggedIn");
    if (loggedIn !== "true") {
      navigate("/login-now");
      return;
    }

    const storedUser = JSON.parse(sessionStorage.getItem("userData")) || null;
    const orderHistory =
      JSON.parse(sessionStorage.getItem("orderHistory")) || [];

    setUser(storedUser);
    setOrders(orderHistory.slice().reverse());
  }, [navigate]);

  const logout = () => {
    sessionStorage.removeItem("isLoggedIn");
    navigate("/login-now");
  };

  return (
    <div className="account-wrapper">
      <div className="container">
        {/* Profile Header */}
        <div className="profile-card">
          <h2>{user?.name || "Welcome Back"}</h2>
          <p className="email">{user?.email}</p>
          <button className="logout-btn" onClick={logout}>
            Logout
          </button>
        </div>

        {/* Quick Actions */}
        <div className="grid-actions">
          <Link className="action-box" to="/cart">
            🛒 <span>My Cart</span>
          </Link>
          <Link className="action-box" to="/track-order">
            🚚 <span>Track Order</span>
          </Link>
          <Link className="action-box" to="/shop">
            🛍️ <span>Continue Shopping</span>
          </Link>
        </div>

        {/* Order History Section */}
        <div className="section-box">
          <h3>Order History</h3>

          {orders.length === 0 ? (
            <p className="empty-msg">No orders found.</p>
          ) : (
            <div className="order-list">
              {orders.map((order) => (
                <div className="order-item" key={order.id}>
                  <div>
                    <strong>{order.orderNumber}</strong>
                    <p className="order-date">
                      {new Date(order.id).toLocaleDateString()}
                    </p>
                  </div>

                  <div className="order-price">
                    ${order.total.toFixed(2)}
                    <span>
                      {order.method === "cod"
                        ? "Cash on Delivery"
                        : "Online Payment"}
                    </span>
                  </div>

                  <Link className="view-btn" to="/track-order">
                    View →
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Saved Address */}
        <div className="section-box">
          <h3>Saved Address</h3>
          {!user?.address ? (
            <p className="empty-msg">No address saved.</p>
          ) : (
            <div className="address-box">
              <p>
                <strong>{user.name}</strong>
              </p>
              <p>{user.address}</p>
              <p>
                {user.city}, {user.postal}
              </p>
              <p>📞 {user.phone}</p>
            </div>
          )}
        </div>
      </div>

      <style>{`
        .account-wrapper { padding: 60px 0; background: #f5f7fa; }
        .profile-card {
          background: white; padding: 30px; border-radius: 20px;
          text-align: center; box-shadow: 0 10px 25px rgba(0,0,0,0.05);
          margin-bottom: 25px;
        }
        .avatar {
          width: 85px; height: 85px; background: #0b61d6; color: white;
          font-size: 36px; font-weight: bold; border-radius: 50%;
          display: flex; justify-content: center; align-items: center;
          margin: 0 auto 12px;
        }
        h2 { margin: 0; font-weight: 700; }
        .email { color: #666; margin-bottom: 15px; }

        .logout-btn {
          padding: 10px 20px; border: none; background: #ff4343;
          color: white; border-radius: 10px; cursor: pointer; font-weight: 600;
        }
        .logout-btn:hover { background: #d63030; }

        .grid-actions {
          display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 12px; margin-bottom: 25px;
        }
        .action-box {
          background: #fff; padding: 16px; text-align: center;
          font-size: 18px; border-radius: 12px; box-shadow: 0 5px 15px rgba(0,0,0,0.04);
          display: flex; flex-direction: column; gap: 5px;
          font-weight: 600; color:#0b61d6; transition: .3s;
        }
        .action-box:hover { transform: translateY(-3px); background:#e9f1ff; }

        .section-box {
          background: white; padding: 25px; border-radius: 15px;
          margin-bottom: 25px; box-shadow: 0 6px 18px rgba(0,0,0,0.05);
        }
        .section-box h3 { margin-bottom: 18px; }

        .order-list { border-top:1px solid #ddd; }
        .order-item {
          display:flex; justify-content:space-between; align-items:center;
          padding:12px 0; border-bottom:1px dashed #ddd;
        }
        .order-price { text-align:right; font-weight:700; }
        .order-price span { display:block; font-size:13px; font-weight:400; color:#666; }

        .view-btn {
          color:#0b61d6; font-weight:600; text-decoration:none;
        }
        .view-btn:hover { text-decoration:underline; }

        .address-box { background:#f3f7ff; padding:15px; border-radius:10px; }

        .empty-msg { color:#777; font-size:15px; }
      `}</style>
    </div>
  );
}

export default MyAccount;
